<template>
    <div id="components-layout-demo-basic">
        <a-layout>
            <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;width:200px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/server.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo School Info</span>
            </div>
          </router-link>
          <div style="width:40px;height:40px;float: right;border-radius: 50%;cursor: pointer">
            <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:26px;">
          </div>
        </div>
      </a-layout-header>
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div style="width:100%;margin-top:40px;">
            <div style="width:100%;margin-bottom:24px;;display:flex;justify-content:space-between;align-items:center;">
              <div class="history-title-text">School Info</div>
              <div>
                <span style="margin:0 16px;color: #000000a6;">学校:</span>
                <a-select default-value="lucy" style="width: 120px">
                    <a-select-option value="lucy">Lucy</a-select-option>
                <!-- <a-select-option v-for="(item,index) in manageList" :key="index" :value="item.employee_id">{{item.nickname}}</a-select-option> -->
                </a-select>
                
                <span style="margin:0 16px;color: #000000a6;">年份:</span>
                <a-select
                    mode="tags"
                    :size="size"
                    placeholder="Please select"
                    :default-value="['a1', 'b2']"
                    style="width: 200px"
                    @change="handleChange"
                    >
                    <a-select-option v-for="i in 25" :key="(i + 9).toString(36) + i">
                        {{ (i + 9).toString(36) + i }}
                    </a-select-option>
    </a-select>

                <span style="margin:0 16px;color: #000000a6;">省份:</span>
                <a-select default-value="lucy" style="width: 120px">
                    <a-select-option value="lucy">Lucy</a-select-option>
                <!-- <a-select-option v-for="(item,index) in manageList" :key="index" :value="item.employee_id">{{item.nickname}}</a-select-option> -->
                </a-select>

                <span style="margin:0 16px;color: #000000a6;">科目:</span>
                <a-select default-value="lucy" style="width: 120px">
                    <a-select-option value="lucy">Lucy</a-select-option>
                <!-- <a-select-option v-for="(item,index) in manageList" :key="index" :value="item.employee_id">{{item.nickname}}</a-select-option> -->
                </a-select>
              </div>
            </div>
            <a-table
                class="school"
                style="margin-top:10px;"
                :loading="loading" 
                :columns="columns"
                :data-source="dataSourse" 
                :rowKey="record => record.id" 
                :pagination="false">
                <span slot="name" slot-scope="text">
                    {{ text == '张银花' ? 'Tina' : text }}
                </span>
            </a-table>
          </div>
        </div>
      </a-layout-content>
        </a-layout>
        <!--   头部   -->
     
   
        
        <Bug></Bug>
    </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'

moment.suppressDeprecationWarnings = true

const columns = [
    {
        title: '学校',
        key: 'university',
        dataIndex: 'university',
        width: 100,
        //   sorter: (a, b) => {
        //     return a.employee_id - b.employee_id
        //   },
    },
    {
        title: '年份',
        key: 'year',
        dataIndex: 'year',
        width: 80,
    },
    {
        title: '省份',
        key: 'province_name',
        dataIndex: 'province_name',
        width: 80,
    },
    {
        title: '科目',
        key: 'sub_name',
        dataIndex: 'sub_name',
        width: 80,
    },
    {
        title: '类型',
        key: 'type',
        dataIndex: 'type',
        width: 80,
    },
    {
        title: '最低分',
        key: 'lowest_score',
        dataIndex: 'lowest_score',
        width: 80,
    },
    {
        title: '最低位次',
        key: 'lowest_rank',
        dataIndex: 'lowest_rank',
        width: 80,
    },
    {
        title: '省控线',
        key: 'proscore',
        dataIndex: 'proscore',
        width: 80,
    },
    {
        title: '录取批次',
        key: 'batch_name',
        dataIndex: 'batch_name',
        width: 120,
    },
]
const dataSourse = []

export default {
    name: 'Leave',
    components: {
        Bug
    },
    data() {
        return {
            columns,
            dataSourse,
            loading:false,
            avatar:'',
            curUserId:'',
            // todayDate: moment()                             //  今天日期
            //     .format('MM-DD-YYYY')
            //     .slice(0, 10),
            // monthDate: moment()                              //  今月
            //     .format('YYYY/MM'),
            // monthPreviewDate: moment()                       //  上个月
            //     .subtract(1, 'month')
            //     .format('YYYY-MM'),
            // monthFormat: 'YYYY/MM',
        }
    },
    methods: {
        moment,
        // 获取jobtitle
        getUniversityList() {
            this.loading=true;
            this.$post(api.tool.universityList, {
                token: localStorage.impr_token,
                employee_id: this.curUserId,
            }).then((res) => {
                if (res.code === 200) {
                    this.dataSourse = res.list.list
                    this.loading=false;
                }
            })
        },
    },
    created() {
        if (localStorage.impr_id && localStorage.impr_token) {
            this.avatar = localStorage.impr_picture
            this.curUserId = localStorage.impr_id
            this.getUniversityList()
        } else {
            this.$router.push({ path: '/' })
        }
    },

}
</script>
<style scoped>
/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}
.container {
  /*width: 60%;*/
  width: 1198px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1659c4;
}

.history-title-text {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
}
</style>

<style>
/* .school {
    width: 1080px;
    margin: auto;
    margin-top: 60px;
} */
</style>